import { initializeAppCheck, ReCaptchaV3Provider, getToken } from 'firebase/app-check';
import { app } from './firebase';

let appCheckInstance = null;

export function initAppCheck() {
  if (appCheckInstance) return appCheckInstance;

  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  if (!siteKey) {
    console.warn('[App Check] No reCAPTCHA site key configured');
    return null;
  }

  appCheckInstance = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(siteKey),
    isTokenAutoRefreshEnabled: true
  });

  console.log('[App Check] Initialized with reCAPTCHA v3');
  return appCheckInstance;
}

export async function getAppCheckToken() {
  if (!appCheckInstance) {
    initAppCheck();
  }

  if (!appCheckInstance) return null;

  try {
    const tokenResult = await getToken(appCheckInstance);
    console.log('[App Check] Token obtained:', tokenResult.token.substring(0, 20) + '...');
    return tokenResult.token;
  } catch (err) {
    console.error('[App Check] Token error:', err);
    return null;
  }
}
